import React from 'react';

type ButtonProps = {
  id: string;
  title: string;
  subtitle: string;
  onClick?: () => void;
  icon: React.ReactNode;
  isNew?: boolean;
};

export const ButtonRedirect = ({ id, onClick, title, subtitle, icon, isNew }: ButtonProps) => {
  return (
    <button
      id={id}
      onClick={onClick || null}
      className='flex h-full min-h-[100px] w-full cursor-pointer flex-col gap-2 rounded border border-gray-100 bg-white p-3 text-left transition-transform duration-200 hover:scale-[1.05]'
    >
      <div className='align-center flex w-full items-center gap-2'>
        <div>{icon}</div>
        <span className='text-base font-bold'>{title}</span>
        {isNew && <span className='ml-auto rounded-2xl bg-[#FAAD14] px-2 py-[3px] text-[11px]'>Novidade</span>}
      </div>
      <span className='text-sm leading-tight text-[rgba(0,0,0,0.45)]'>{subtitle}</span>
    </button>
  );
};
